"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _exenv = require("exenv");
var fetch = require('isomorphic-fetch');
require('abortcontroller-polyfill/dist/polyfill-patch-fetch');

// this is polyfill for fech with timeout
var _default = exports.default = function _default(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var retries = 3;
  var retryDelay = 1000;
  var retryOn = [];
  if (options && options.retries !== undefined) {
    if (isPositiveInteger(options.retries)) {
      retries = options.retries;
    } else {
      throw new ArgumentError('retries must be a positive integer');
    }
  }
  if (options && options.retryDelay !== undefined) {
    if (isPositiveInteger(options.retryDelay) || typeof options.retryDelay === 'function') {
      retryDelay = options.retryDelay;
    } else {
      throw new ArgumentError('retryDelay must be a positive integer or a function returning a positive integer');
    }
  }
  if (options && options.retryOn) {
    if (Array.isArray(options.retryOn) || typeof options.retryOn === 'function') {
      retryOn = options.retryOn;
    } else {
      throw new ArgumentError('retryOn property expects an array or function');
    }
  }
  if (typeof Promise == 'undefined') {
    require('es6-promise').polyfill();
  }
  return new Promise(function (resolve, reject) {
    var wrappedFetch = function wrappedFetch(attempt) {
      var abortTimeout = null;
      if (options.timeout && _exenv.canUseDOM) {
        var controller = new AbortController();
        options.signal = controller.signal;
        if (abortTimeout) {
          clearTimeout(abortTimeout);
        }
        abortTimeout = setTimeout(function () {
          controller.abort();
        }, options.timeout || 30000);
      }
      fetch(url, options).then(function (response) {
        if (abortTimeout) {
          clearTimeout(abortTimeout);
          abortTimeout = null;
        }
        if (Array.isArray(retryOn) && retryOn.indexOf(response.status) === -1) {
          resolve(response);
        } else if (typeof retryOn === 'function') {
          if (retryOn(attempt, null, response)) {
            retry(attempt, null, response);
          } else {
            resolve(response);
          }
        } else {
          if (attempt < retries) {
            retry(attempt, null, response);
          } else {
            resolve(response);
          }
        }
      }).catch(function (error) {
        if (typeof retryOn === 'function') {
          if (retryOn(attempt, error, null)) {
            retry(attempt, error, null);
          } else {
            reject(error);
          }
        } else if (attempt < retries) {
          retry(attempt, error, null);
        } else {
          reject(error);
        }
      });
    };
    function retry(attempt, error, response) {
      var delay = typeof retryDelay === 'function' ? retryDelay(attempt, error, response) : retryDelay > 1000 ? 1000 : retryDelay; //set max retryDelay to 1000ms
      setTimeout(function () {
        wrappedFetch(++attempt);
      }, delay);
    }
    wrappedFetch(0);
  });
};
Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};
function isPositiveInteger(value) {
  return Number.isInteger(value) && value >= 0;
}
function ArgumentError(message) {
  this.name = 'ArgumentError';
  this.message = message;
}